// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_fa-2";
export var aiChatCartContainerExit = "_fa-4";
export var aiChatContainerLarge = "_fa-0";
export var aiChatContainerSmall = "_fa-1";
export var aiChatIcon = "_fa-6";
export var slideInFromRight = "_fa-3";
export var slideOutToRight = "_fa-5";